module.exports = __webpack_public_path__ + "img/7.2468916.png";